import React, { useState } from 'react';

const TBOSupplierHighlight = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [billingCycle, setBillingCycle] = useState(1); // 1 = Monthly, 2 = Annually

  // Company Information - Zotrai (YOUR COMPANY)
  const companyInfo = {
    name: "Zotrai",
    themeColor: "#FF7F00",
    description: "Your trusted B2B travel technology partner",
    founded: "2020",
    headquarters: "India",
    agents: "10,000+",
    suppliers: "50+",
    countries: "100+",
    uptime: "99.9%",
    apiCalls: "100M+",
    team: "100+",
    email: "support@zotrai.com",
    phone: "+91-7207642485"
  };

   // Why Suppliers Choose Zotrai - REAL DATA
  const whyZotraiData = {
    benefits: [
        {
        id: 1,
        title: "Single API Integration, Multiple Connections",
        description: "Connect once with Zotrai and get instant access to all our partner suppliers - no multiple integrations needed",
        icon: "ri-plug-line",
        stat: "1",
        statLabel: "Integration"
      },
     {
  id: 2,
  title: "Launch B2B, B2C & Corporate Portals",
  description: "Fully customizable multi-agent, direct-sell, and corporate booking platforms under your brand",
  icon: "ri-window-line",
  stat: "All-in-One",
  statLabel: "Portal Suite"
},
    
      {
  id: 3,
  title: "Save 95% on Integration Costs",
  description: "No setup fees, no integration charges.",
icon: "ri-coins-line",

  stat: "95%",
  statLabel: "Cost Savings"
},
      {
        id: 4,
        title: "Real-time Analytics Dashboard",
        description: "Track your inventory performance, booking patterns, and agent behavior with detailed analytics",
        icon: "ri-bar-chart-2-line",
        stat: "24/7",
        statLabel: "Monitoring"
      },
      {
        id: 5,
        title: "99.9% Uptime Guarantee",
        description: "Enterprise-grade infrastructure with redundant systems ensuring your APIs are always available",
        icon: "ri-shield-check-line",
        stat: "99.9%",
        statLabel: "Uptime"
      },
      {
        id: 6,
        title: "Dedicated Account Manager",
        description: "Every supplier gets a dedicated technical account manager for seamless integration and support",
        icon: "ri-customer-service-line",
        stat: "24/7",
        statLabel: "Support"
      }
    ],
    process: [
      {
        step: 1,
        title: "Add Your API Credentials",
        description: "Just Login, paste your API keys, and we handle the rest – zero development effort"
      },
       {
        step: 2,
        title: "Select & Customize Template",
        description: "Pick from our library of 100+ responsive templates and match your brand identity"
      },
      {
        step: 3,
        title: "Go Live Instantly",
        description: "Deploy to production in one click and start accepting real bookings"
      }
    ]
  };


  // SEO-friendly structured data for TBO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "TBO",
    "description": "Global travel distribution platform offering comprehensive hotel inventory and dynamic packaging capabilities",
    "url": "https://www.tbo.com",
    "areaServed": "Worldwide",
    "serviceType": ["Hotel Booking API", "Flight Booking API", "Dynamic Packaging", "Travel Technology"]
  };

  // TBO specific data
  const tboData = {
    name: "TBO",
    description: "Global travel distribution platform offering comprehensive hotel inventory and dynamic packaging capabilities. One of the world's largest B2B travel platforms with presence in 100+ countries.",
    longDescription: "TBO is a leading global travel distribution platform that connects travel buyers and suppliers across the world. With over a decade of experience, TBO has established itself as a trusted partner for travel agencies, tour operators, and corporate travel managers. Their comprehensive platform offers access to millions of hotel properties, hundreds of airlines, and thousands of activities worldwide.",
    founded: "2006",
    headquarters: "Gurgaon, India",
    employees: "1000+",
    countries: "100+",
    hotels: "2M+",
    airlines: "400+",
    activities: "50K+",
    apiCalls: "500M+",
    agents: "60,000+",
    themeColor: "#FF4B4B", // TBO's brand red color
    website: "https://www.tbo.com",
    apiType: "RESTful/SOAP API",
    integrationType: "Direct API Integration",
    support: "24/7 Technical Support"
  };

  // Key features of TBO
  const features = [
    {
      icon: "🏨",
      title: "2M+ Hotel Properties",
      description: "Access to millions of hotels, resorts, and alternative accommodations worldwide"
    },
    {
      icon: "✈️",
      title: "400+ Airlines",
      description: "Comprehensive flight inventory including LCCs and full-service carriers"
    },
    {
      icon: "🎯",
      title: "Dynamic Packaging",
      description: "Create customized holiday packages with flights, hotels, and activities"
    },
    {
      icon: "💰",
      title: "Competitive B2B Rates",
      description: "Exclusive wholesale rates and negotiated corporate discounts"
    }
  ];

  // Services offered by TBO
  const services = [
    {
      id: 1,
      title: "Hotel Booking API",
      description: "Access to over 2 million hotel properties worldwide with real-time availability, dynamic pricing, and instant confirmation.",
      features: [
        "Real-time availability & pricing",
        "Multi-language content",
        "High-resolution images",
        "Cancellation policies"
      ],
      icon: "🏨"
    },
    {
      id: 2,
      title: "Flight Booking API",
      description: "Comprehensive flight inventory from 400+ airlines including GDS content and LCCs with best fare guarantees.",
      features: [
        "Multi-GDS integration",
        "LCC content",
        "Group bookings",
        "Seat selection"
      ],
      icon: "✈️"
    },
    {
      id: 3,
      title: "Activities & Tours",
      description: "Book thousands of activities, tours, and experiences at destinations worldwide.",
      features: [
        "Skip-the-line tickets",
        "Local experiences",
        "Adventure activities",
        "City tours"
      ],
      icon: "🎫"
    }
  ];

  // Supplier logos array with navigation paths
  const suppliers = [
    { 
      id: 1, 
      name: "Tripjack", 
      logo: "/assets/images/suppliers/tripjack.png",
      path: "/supplier/trip-jack"
    },
    { 
      id: 2, 
      name: "TBO", 
      logo: "/assets/images/suppliers/tbo.png",
      path: "/supplier/tbo"
    },
    { 
      id: 3, 
      name: "Akbar Travels", 
      logo: "/assets/images/suppliers/akbar.png",
      path: "/supplier/akbar-travels"
    },
    { 
      id: 4, 
      name: "RezLive", 
      logo: "/assets/images/suppliers/rezlive.png",
      path: "/supplier/rezlive"
    },
    { 
      id: 5, 
      name: "GRN Connect", 
      logo: "/assets/images/suppliers/grn.png",
      path: "/supplier/grn-connect"
    },
    { 
      id: 6, 
      name: "Riya Travel", 
      logo: "/assets/images/suppliers/riya.png",
      path: "/supplier/riya-travel"
    },
    { 
      id: 7, 
      name: "Viator", 
      logo: "/assets/images/suppliers/viator.png",
      path: "/supplier/viator"
    },
    { 
      id: 8, 
      name: "Air iQ", 
      logo: "/assets/images/suppliers/airiq.png",
      path: "/supplier/air-iq"
    }
  ];

  // Pricing plans data
  const plans = [
    {
      id: 1,
      name: "Starter",
      description: "🚀 All-in-one powerful plan with complete access to every feature.",
      monthly: 2999,
      annually: 29999,
      popular: true,
      emoji: "🚀",
      features: [
        "Search, compare, and book flights from top global suppliers in one place",
        "Access and connect with 1,000+ verified global DMCs",
        "Smart accounting suite with ledgers, invoices, supplier settlements, and corporate payments",
        "Capture leads directly from social media and run promotions from a single dashboard",
        "Generate professional itineraries in minutes using AI",
        "AI-powered visa processing and document management system",
        "One unified platform for Flights, Hotels, Visas, Cars, Sightseeing, and more",
        "Integrated and secure payment gateway",
        "Plug in and manage your own supplier APIs seamlessly",
        "AI-based WhatsApp automation for leads, follow-ups, and customer support",
        "Unlimited email marketing and promotional campaigns",
        "Advanced reports and analytics for sales, revenue, and performance tracking",
      ],
      addons: [
        "Launch your own B2C booking website for customers in minutes – just INR 999",
        "Launch a full-featured B2C travel portal with flights, hotels, and packages using your preferred suppliers – INR 1,999",
        "Launch a B2B travel portal for your agent network with flights, hotels, and packages – INR 1,999",
        "Launch a B2E corporate travel portal for your business clients with flights, hotels, and packages – INR 1,999",
      ],
    },
  ];

  const getAccentColor = (planName) => {
    if (planName === "Starter") return "#10B981";
    if (planName === "Pro") return "#3B82F6";
    return "#8B5CF6";
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${companyInfo.email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${companyInfo.phone.replace(/[^0-9+]/g, '')}`;
  };

  const handleSupplierClick = (path) => {
    window.location.href = path;
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>TBO - Global Travel Distribution Platform | Zotrai</title>
        <meta name="description" content="TBO is a leading global travel distribution platform offering comprehensive hotel inventory, flight bookings, and dynamic packaging capabilities through Zotrai integration." />
        <meta name="keywords" content="TBO supplier, travel distribution, hotel booking API, flight API, B2B travel platform, travel technology" />
        <link rel="canonical" href="https://yourcompany.com/supplier/tbo" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="TBO - Global Travel Distribution Platform" />
        <meta property="og:description" content="Connect with TBO's global inventory of 2M+ hotels and 400+ airlines through Zotrai's single API integration." />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Main Content with tbo- prefix */}
      <div className="tbo-supplier-container">
        {/* Header Section - TBO Hero */}
        <header className="tbo-header">
          <div className="tbo-container">
            <h1 className="tbo-title">
              <span className="tbo-highlight" style={{ color: tboData.themeColor }}>TBO</span>
              <br />
              Global Travel Distribution Platform
            </h1>
            <p className="tbo-subtitle">
              {tboData.description}
            </p>
          </div>
        </header>

        {/* Tabs Navigation - Same as Tripjack */}
        <div className="tbo-tabs-container">
          <div className="tbo-container">
            <div className="tbo-tabs">
              <button 
                className={`tbo-tab ${activeTab === 'about' ? 'tbo-tab-active' : ''}`}
                onClick={() => setActiveTab('about')}
              >
                About
              </button>
              <button 
                className={`tbo-tab ${activeTab === 'services' ? 'tbo-tab-active' : ''}`}
                onClick={() => setActiveTab('services')}
              >
                Services
              </button>
              <button 
                className={`tbo-tab ${activeTab === 'technology' ? 'tbo-tab-active' : ''}`}
                onClick={() => setActiveTab('technology')}
              >
                Technology
              </button>
              <button 
                className={`tbo-tab ${activeTab === 'whyzotrai' ? 'tbo-tab-active' : ''}`}
                onClick={() => setActiveTab('whyzotrai')}
              >
                Why Zotrai <span className="tbo-tab-badge">For Suppliers</span>
              </button>
              <button 
                className={`tbo-tab ${activeTab === 'suppliers' ? 'tbo-tab-active' : ''}`}
                onClick={() => setActiveTab('suppliers')}
              >
                Suppliers
              </button>
              <button 
                className={`tbo-tab ${activeTab === 'pricing' ? 'tbo-tab-active' : ''}`}
                onClick={() => setActiveTab('pricing')}
              >
                Pricing
              </button>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="tbo-tab-content">
          {activeTab === 'about' && (
            <section className="tbo-about">
              <div className="tbo-container">
                <div className="tbo-grid">
                  <div className="tbo-about-content">
                    <h2 className="tbo-section-title">About <span className="tbo-accent" style={{ color: tboData.themeColor }}>TBO</span></h2>
                    <p className="tbo-text">
                      {tboData.longDescription}
                    </p>
                    
                    <div className="tbo-features">
                      {features.map((feature, index) => (
                        <div key={index} className="tbo-feature">
                          <span className="tbo-feature-icon">{feature.icon}</span>
                          <div>
                            <h4>{feature.title}</h4>
                            <p>{feature.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="tbo-card">
                    <h3 className="tbo-card-title">TBO at a Glance</h3>
                    <ul className="tbo-list">
                      <li className="tbo-list-item">
                        <span className="tbo-check" style={{ color: tboData.themeColor }}>✓</span>
                        2M+ Hotel Properties
                      </li>
                      <li className="tbo-list-item">
                        <span className="tbo-check" style={{ color: tboData.themeColor }}>✓</span>
                        400+ Airline Connections
                      </li>
                      <li className="tbo-list-item">
                        <span className="tbo-check" style={{ color: tboData.themeColor }}>✓</span>
                        Multi-GDS Integration
                      </li>
                      <li className="tbo-list-item">
                        <span className="tbo-check" style={{ color: tboData.themeColor }}>✓</span>
                        100+ Countries Coverage
                      </li>
                      <li className="tbo-list-item">
                        <span className="tbo-check" style={{ color: tboData.themeColor }}>✓</span>
                        60,000+ Active Agents
                      </li>
                      <li className="tbo-list-item">
                        <span className="tbo-check" style={{ color: tboData.themeColor }}>✓</span>
                        24/7 Technical Support
                      </li>
                      <li className="tbo-list-item">
                        <span className="tbo-check" style={{ color: tboData.themeColor }}>✓</span>
                        Real-time Pricing Engine
                      </li>
                      <li className="tbo-list-item">
                        <span className="tbo-check" style={{ color: tboData.themeColor }}>✓</span>
                        Instant Booking Confirmation
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'services' && (
            <section className="tbo-services">
              <div className="tbo-container">
                <h2 className="tbo-section-title tbo-text-center">
                  Comprehensive Travel Solutions
                </h2>
                <p className="tbo-section-subtitle">
                  Through our integration with TBO, we deliver end-to-end travel technology solutions
                </p>

                <div className="tbo-services-grid">
                  {services.map((service) => (
                    <div key={service.id} className="tbo-service-card">
                      <div className="tbo-service-icon">{service.icon}</div>
                      <h3 className="tbo-service-title">{service.title}</h3>
                      <p className="tbo-service-description">{service.description}</p>
                      <ul className="tbo-service-list">
                        {service.features.map((feature, index) => (
                          <li key={index} className="tbo-service-list-item">
                            <span className="tbo-dot" style={{ color: tboData.themeColor }}>•</span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {activeTab === 'technology' && (
            <section className="tbo-technology">
              <div className="tbo-container">
                <div className="tbo-grid">
                  <div className="tbo-integration-box">
                    <h3 className="tbo-card-title">Seamless Integration</h3>
                    <p className="tbo-text">
                      Our integration with TBO's robust APIs ensures smooth data flow, real-time updates, and reliable performance. This technology partnership enables us to deliver exceptional travel services.
                    </p>
                    <div className="tbo-tags">
                      <span className="tbo-tag">RESTful APIs</span>
                      <span className="tbo-tag">SOAP APIs</span>
                      <span className="tbo-tag">Real-time Data</span>
                      <span className="tbo-tag">Webhook Support</span>
                      <span className="tbo-tag">Scalable Architecture</span>
                      <span className="tbo-tag">High Availability</span>
                      <span className="tbo-tag">Multi-language</span>
                      <span className="tbo-tag">Enterprise Security</span>
                    </div>
                  </div>

                  <div className="tbo-benefits-box">
                    <h3 className="tbo-card-title">Key Advantages</h3>
                    <ul className="tbo-benefits-list">
                      <li className="tbo-benefits-item">
                        <span className="tbo-benefits-icon">⚡</span>
                        Lightning-fast API response times
                      </li>
                      <li className="tbo-benefits-item">
                        <span className="tbo-benefits-icon">🛡️</span>
                        Enterprise-grade security protocols
                      </li>
                      <li className="tbo-benefits-item">
                        <span className="tbo-benefits-icon">🎧</span>
                        Dedicated technical support
                      </li>
                      <li className="tbo-benefits-item">
                        <span className="tbo-benefits-icon">👥</span>
                        Experienced integration team
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'whyzotrai' && (
            <section className="tbo-why-zotrai-section">
              <div className="tbo-container">
                {/* Header */}
                <div className="tbo-why-header">
                  <span className="tbo-why-badge" style={{ background: `${companyInfo.themeColor}15`, color: companyInfo.themeColor }}>
                    <i className="ri-question-line"></i> WHY SUPPLIERS CHOOSE ZOTRAI
                  </span>
                  <h2 className="tbo-section-title">
                    Your Growth Partner in <span className="tbo-accent" style={{ color: companyInfo.themeColor }}>Travel Distribution</span>
                  </h2>
                  <p className="tbo-section-subtitle">
                    Join 50+ leading travel suppliers who trust us to connect them with travel agents
                  </p>
                </div>

                {/* Benefits Grid */}
                <div className="tbo-benefits-grid-full">
                  {whyZotraiData.benefits.map((benefit) => (
                    <div key={benefit.id} className="tbo-benefit-card">
                      <div className="tbo-benefit-icon-wrapper" style={{ background: `${companyInfo.themeColor}15` }}>
                        <i className={benefit.icon} style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="tbo-benefit-content">
                        <h3>{benefit.title}</h3>
                        <p>{benefit.description}</p>
                        <div className="tbo-benefit-stat">
                          <span className="tbo-stat-highlight" style={{ color: companyInfo.themeColor }}>{benefit.stat}</span>
                          <span className="tbo-stat-label">{benefit.statLabel}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Integration Process */}
                <div className="tbo-integration-process">
                  <h3 className="tbo-process-title">Simple 3-Step Integration</h3>
                  <div className="tbo-process-steps">
                    {whyZotraiData.process.map((step) => (
                      <div key={step.step} className="tbo-process-step">
                        <div className="tbo-step-number" style={{ background: companyInfo.themeColor }}>{step.step}</div>
                        <h4>{step.title}</h4>
                        <p>{step.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Contact Section */}
                <div className="tbo-contact-section">
                  <h3>Ready to Join Our Supplier Network?</h3>
                  <p>Connect with ravel agents through a single integration</p>
                  
                  <div className="tbo-contact-info">
                    <div className="tbo-contact-item" onClick={handleEmailClick}>
                      <div className="tbo-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-mail-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="tbo-contact-details">
                        <span className="tbo-contact-label">Email Support</span>
                        <span className="tbo-contact-value">{companyInfo.email}</span>
                      </div>
                    </div>

                    <div className="tbo-contact-item" onClick={handlePhoneClick}>
                      <div className="tbo-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-phone-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="tbo-contact-details">
                        <span className="tbo-contact-label">Phone Support</span>
                        <span className="tbo-contact-value">{companyInfo.phone}</span>
                      </div>
                    </div>
                  </div>

                  <p className="tbo-contact-note">
                    Our support team is available 24/7 to assist you with any questions
                  </p>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'suppliers' && (
            <section className="tbo-suppliers-section">
              <div className="tbo-container">
                {/* Section Header */}
                <div className="tbo-suppliers-header">
                  <span className="tbo-suppliers-badge">
                    <i className="ri-handshake-line"></i> OUR INTEGRATED SUPPLIERS
                  </span>
                  <h2 className="tbo-section-title">
                    Connect With <span className="tbo-accent">Leading Travel Suppliers</span>
                  </h2>
                  <p className="tbo-section-subtitle">
                    Direct integrations with industry-leading travel suppliers worldwide
                  </p>
                </div>

                {/* Clickable Logo Grid */}
                <div className="tbo-logo-grid">
                  {suppliers.map((supplier) => (
                    <div 
                      key={supplier.id} 
                      className="tbo-logo-item tbo-clickable"
                      onClick={() => handleSupplierClick(supplier.path)}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleSupplierClick(supplier.path);
                        }
                      }}
                    >
                      <div className="tbo-logo-wrapper">
                        <img 
                          src={supplier.logo} 
                          alt={supplier.name}
                          className="tbo-supplier-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://via.placeholder.com/80x40?text=${supplier.name.charAt(0)}`;
                          }}
                        />
                      </div>
                      <span className="tbo-logo-name">{supplier.name}</span>
                      <span className="tbo-view-details-hint">
                        View Details <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  ))}
                </div>

                {/* Simple Stats */}
                <div className="tbo-supplier-stats-simple">
                
                  <div className="tbo-stat-simple">
                    <span className="tbo-stat-number">1M+</span>
                    <span className="tbo-stat-label">Hotel Properties</span>
                  </div>
                  <div className="tbo-stat-simple">
                    <span className="tbo-stat-number">80+</span>
                    <span className="tbo-stat-label">Airlines</span>
                  </div>
                  <div className="tbo-stat-simple">
                    <span className="tbo-stat-number">300K+</span>
                    <span className="tbo-stat-label">Activities</span>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'pricing' && (
            <section className="tbo-pricing-section">
              <div className="tbo-container">
                <div className="tbo-pricing-header">
                  <h2 className="tbo-section-title tbo-text-center">
                    Plans & <span className="tbo-accent">Pricing</span>
                  </h2>
                  <p className="tbo-section-subtitle">
                    Pick the plan that's right for your business growth
                  </p>
                  
                  {/* Billing Toggle */}
                  <div className="tbo-billing-toggle">
                    <button
                      className={`tbo-toggle-btn ${billingCycle === 1 ? 'tbo-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(1)}
                    >
                      Monthly
                    </button>
                    <button
                      className={`tbo-toggle-btn ${billingCycle === 2 ? 'tbo-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(2)}
                    >
                      Annually
                      <span className="tbo-save-badge">Save 20%</span>
                    </button>
                  </div>
                </div>

                {/* Pricing Cards */}
                <div className="tbo-pricing-grid">
                  {plans.map((plan) => {
                    const isMonthly = billingCycle === 1;
                    const accentColor = getAccentColor(plan.name);
                    
                    return (
                      <div key={plan.id} className="tbo-pricing-card-enhanced">
                        {plan.popular && (
                          <div className="tbo-popular-badge">
                            ⭐ MOST POPULAR
                          </div>
                        )}

                        <div className="tbo-pricing-card-content">
                          {/* Pricing Side */}
                          <div className="tbo-pricing-left" style={{ backgroundColor: plan.popular ? '#F4F9FF' : '#ffffff' }}>
                            <div className="tbo-pricing-emoji">{plan.emoji}</div>
                            <h3 className="tbo-pricing-name">{plan.name}</h3>
                            <p className="tbo-pricing-description">{plan.description}</p>

                            <div className="tbo-pricing-amount">
                           
                              <span className="tbo-price">
                                {isMonthly ? plan.monthly.toLocaleString() : plan.annually.toLocaleString()}
                              </span>
                              <span className="tbo-pricing-period">
                                INR/{isMonthly ? 'month' : 'year'}
                              </span>
                            </div>

                            <button 
                              className="tbo-pricing-cta"
                              style={{ backgroundColor: accentColor }}
                              onClick={() => window.location.href = '/signup'}
                            >
                              Start Free Trial <i className="ri-arrow-right-line"></i>
                            </button>

                            {/* Quick 3-Step Setup */}
                            <div className="tbo-quick-setup">
                              <h4 className="tbo-setup-title">Quick 3-Step Setup</h4>
                              <div className="tbo-setup-steps">
                                <div className="tbo-setup-step">
                                  <div className="tbo-step-marker" style={{ background: accentColor }}>1</div>
                                  <div className="tbo-step-content">
                                    <strong>Sign Up & Choose Plan</strong>
                                    <span>Create your account in 30 seconds - no credit card required</span>
                                  </div>
                                </div>
                                <div className="tbo-setup-step">
                                  <div className="tbo-step-marker" style={{ background: accentColor }}>2</div>
                                  <div className="tbo-step-content">
                                    <strong>Select Your Suppliers</strong>
                                    <span>Choose from leading travel suppliers with one click</span>
                                  </div>
                                </div>
                                <div className="tbo-setup-step">
                                  <div className="tbo-step-marker" style={{ background: accentColor }}>3</div>
                                  <div className="tbo-step-content">
                                    <strong>Launch Your Portal</strong>
                                    <span>Go live with your branded website in minutes</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Features Side */}
                          <div className="tbo-pricing-right">
                            <h5 className="tbo-features-title" style={{ color: accentColor }}>
                              Included in {plan.name}
                            </h5>
                            
                            <div className="tbo-features-list">
                              {plan.features.map((feature, index) => (
                                <div key={index} className="tbo-feature-item">
                                  <div className="tbo-feature-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-check-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{feature}</span>
                                </div>
                              ))}
                            </div>

                            <h5 className="tbo-features-title tbo-addons-title" style={{ color: accentColor }}>
                              Add-Ons
                            </h5>
                            
                            <div className="tbo-addons-list">
                              {plan.addons.map((addon, index) => (
                                <div key={index} className="tbo-addon-item">
                                  <div className="tbo-addon-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-add-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{addon}</span>
                                </div>
                              ))}
                            </div>

                            <div className="tbo-pricing-footer">
                              <span>✓ Transparent pricing, no hidden fees</span>
                              <span className="tbo-support-link" style={{ color: accentColor }}>
                                Need help? Chat with us
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          )}
        </div>
      </div>

      {/* Styles with tbo- prefix */}
      <style jsx>{`
        .tbo-supplier-container {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
          line-height: 1.6;
          color: #1e293b;
        }

        .tbo-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Header Styles */
        .tbo-header {
          background: #ffffff;
          color: #1e293b;
          padding: 80px 0 40px;
          text-align: center;
        }

        .tbo-title {
          font-size: 3.5rem;
          font-weight: 800;
          margin: 0 0 15px;
          line-height: 1.2;
          color: #1e293b;
        }

        .tbo-highlight {
          font-size: 4rem;
          display: inline-block;
          font-weight: 800;
        }

        .tbo-subtitle {
          font-size: 1.25rem;
          max-width: 700px;
          margin: 0 auto;
          color: #475569;
        }

        /* Tabs Navigation */
        .tbo-tabs-container {
          background: #ffffff;
          border-bottom: 2px solid #e2e8f0;
          margin-bottom: 40px;
          position: sticky;
          top: 0;
          z-index: 100;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }

        .tbo-tabs {
          display: flex;
          gap: 30px;
          overflow-x: auto;
          padding: 0 24px;
        }

        .tbo-tab {
          background: none;
          border: none;
          padding: 16px 0;
          font-size: 1rem;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          position: relative;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
        }

        .tbo-tab:hover {
          color: #0f172a;
        }

        .tbo-tab-active {
          color: #0f172a;
        }

        .tbo-tab-active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 3px;
          background: ${tboData.themeColor};
        }

        .tbo-tab-badge {
          background: ${tboData.themeColor};
          color: white;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          font-weight: 500;
        }

        /* About Section */
        .tbo-about {
          padding: 40px 0 60px;
          background: #ffffff;
        }

        .tbo-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 50px;
          align-items: start;
        }

        .tbo-section-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .tbo-text-center {
          text-align: center;
        }

        .tbo-accent {
          position: relative;
          display: inline-block;
        }

        .tbo-accent::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100%;
          height: 4px;
          background: ${tboData.themeColor};
          border-radius: 2px;
        }

        .tbo-text {
          font-size: 1.1rem;
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.8;
        }

        .tbo-features {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          margin-top: 30px;
        }

        .tbo-feature {
          display: flex;
          gap: 15px;
          padding: 20px;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .tbo-feature:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          border-color: ${tboData.themeColor};
        }

        .tbo-feature-icon {
          font-size: 2rem;
          min-width: 50px;
        }

        .tbo-feature h4 {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 5px;
          color: #0f172a;
        }

        .tbo-feature p {
          font-size: 0.95rem;
          color: #475569;
          margin: 0;
        }

        .tbo-card {
          background: white;
          padding: 40px;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
        }

        .tbo-card-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .tbo-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .tbo-list-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          font-size: 1rem;
          color: #334155;
        }

        .tbo-check {
          font-weight: bold;
          font-size: 1.2rem;
        }

        /* Services Section */
        .tbo-services {
          padding: 40px 0 60px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .tbo-section-subtitle {
          font-size: 1.25rem;
          color: #475569;
          text-align: center;
          max-width: 700px;
          margin: 0 auto 50px;
        }

        .tbo-services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .tbo-service-card {
          background: white;
          padding: 35px 25px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
        }

        .tbo-service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: ${tboData.themeColor};
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .tbo-service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(255, 75, 75, 0.1);
        }

        .tbo-service-card:hover::before {
          transform: scaleX(1);
        }

        .tbo-service-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }

        .tbo-service-title {
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .tbo-service-description {
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .tbo-service-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .tbo-service-list-item {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          color: #475569;
          font-size: 0.95rem;
        }

        .tbo-dot {
          font-weight: bold;
        }

        /* Technology Section */
        .tbo-technology {
          padding: 40px 0 60px;
          background: white;
        }

        .tbo-integration-box,
        .tbo-benefits-box {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          padding: 40px;
          border-radius: 24px;
          border: 1px solid #eef2f6;
        }

        .tbo-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 25px;
        }

        .tbo-tag {
          background: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-size: 0.9rem;
          color: ${tboData.themeColor};
          font-weight: 500;
          border: 1px solid ${tboData.themeColor}30;
          transition: all 0.3s ease;
        }

        .tbo-tag:hover {
          background: ${tboData.themeColor};
          color: white;
          border-color: ${tboData.themeColor};
          transform: scale(1.05);
        }

        .tbo-benefits-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .tbo-benefits-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          font-size: 1.1rem;
          color: #1e293b;
        }

        .tbo-benefits-icon {
          font-size: 1.5rem;
          background: white;
          width: 45px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        /* Why Zotrai Section */
        .tbo-why-zotrai-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .tbo-why-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .tbo-why-badge {
          display: inline-block;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
        }

        .tbo-benefits-grid-full {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
          margin-bottom: 50px;
        }

        .tbo-benefit-card {
          display: flex;
          gap: 20px;
          background: #f8fafc;
          padding: 25px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
        }

        .tbo-benefit-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.05);
          border-color: ${companyInfo.themeColor};
        }

        .tbo-benefit-icon-wrapper {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .tbo-benefit-icon-wrapper i {
          font-size: 2rem;
        }

        .tbo-benefit-content h3 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 8px;
          color: #0f172a;
        }

        .tbo-benefit-content p {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 12px;
          line-height: 1.6;
        }

        .tbo-benefit-stat {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .tbo-stat-highlight {
          font-size: 1.2rem;
          font-weight: 700;
        }

        .tbo-integration-process {
          text-align: center;
          margin: 60px 0;
        }

        .tbo-process-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 40px;
          color: #0f172a;
        }

        .tbo-process-steps {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .tbo-process-step {
          text-align: center;
          padding: 30px;
          background: #f8fafc;
          border-radius: 20px;
          border: 1px solid #eef2f6;
        }

        .tbo-process-step .tbo-step-number {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 auto 20px;
        }

        /* Contact Section */
        .tbo-contact-section {
          background: #ffffff;
          padding: 60px;
          border-radius: 30px;
          text-align: center;
          color: #0f172a;
          margin-top: 60px;
          border: 2px solid #eef2f6;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        }

        .tbo-contact-section h3 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .tbo-contact-section p {
          font-size: 1.2rem;
          color: #475569;
          margin-bottom: 40px;
        }

        .tbo-contact-info {
          display: flex;
          justify-content: center;
          gap: 30px;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }

        .tbo-contact-item {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 20px 30px;
          background: #f8fafc;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 280px;
        }

        .tbo-contact-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border-color: ${companyInfo.themeColor};
        }

        .tbo-contact-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .tbo-contact-icon i {
          font-size: 1.8rem;
        }

        .tbo-contact-details {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .tbo-contact-label {
          font-size: 0.85rem;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .tbo-contact-value {
          font-size: 1.2rem;
          font-weight: 600;
          color: #0f172a;
        }

        .tbo-contact-note {
          font-size: 0.95rem !important;
          color: #64748b !important;
          margin-top: 20px;
          margin-bottom: 0 !important;
        }

        /* Suppliers Section */
        .tbo-suppliers-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .tbo-suppliers-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .tbo-suppliers-badge {
          display: inline-block;
          background: linear-gradient(135deg, #2563eb15, #7c3aed15);
          color: #2563eb;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
          border: 1px solid #2563eb20;
        }

        .tbo-suppliers-badge i {
          margin-right: 8px;
        }

        .tbo-logo-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          margin-bottom: 50px;
        }

        .tbo-logo-item {
          text-align: center;
          padding: 20px;
          background: white;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .tbo-logo-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(37, 99, 235, 0.15);
          border-color: #2563eb;
        }

        .tbo-logo-item:hover .tbo-view-details-hint {
          opacity: 1;
          transform: translateY(0);
        }

        .tbo-logo-wrapper {
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 15px;
        }

        .tbo-supplier-logo {
          max-width: 120px;
          max-height: 60px;
          object-fit: contain;
          transition: transform 0.3s ease;
        }

        .tbo-logo-item:hover .tbo-supplier-logo {
          transform: scale(1.05);
        }

        .tbo-logo-name {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1e293b;
          display: block;
          margin-bottom: 5px;
        }

        .tbo-view-details-hint {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
          color: #2563eb;
          font-weight: 500;
          opacity: 0;
          transform: translateY(10px);
          transition: all 0.3s ease;
        }

        .tbo-supplier-stats-simple {
          display: flex;
          justify-content: space-around;
          align-items: center;
          background: linear-gradient(135deg, #f8fafc, #ffffff);
          padding: 30px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          flex-wrap: wrap;
          gap: 20px;
        }

        .tbo-stat-simple {
          text-align: center;
        }

        .tbo-stat-simple .tbo-stat-number {
          display: block;
          font-size: 2rem;
          font-weight: 800;
          color: #2563eb;
          line-height: 1.2;
        }

        .tbo-stat-simple .tbo-stat-label {
          font-size: 0.9rem;
          color: #64748b;
        }

        /* Pricing Section */
        .tbo-pricing-section {
          padding: 40px 0 80px;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        }

        .tbo-pricing-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .tbo-billing-toggle {
          display: inline-flex;
          background: white;
          padding: 4px;
          border-radius: 50px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          margin-top: 20px;
        }

        .tbo-toggle-btn {
          border: none;
          padding: 12px 32px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: transparent;
          color: #64748b;
          position: relative;
        }

        .tbo-toggle-active {
          background: #2563eb;
          color: white;
        }

        .tbo-save-badge {
          background: #fbbf24;
          color: #1e293b;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          margin-left: 8px;
          font-weight: 500;
        }

        .tbo-pricing-grid {
          max-width: 1000px;
          margin: 0 auto;
        }

        .tbo-pricing-card-enhanced {
          background: white;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .tbo-pricing-card-enhanced:hover {
          transform: translateY(-5px);
          box-shadow: 0 30px 60px rgba(37, 99, 235, 0.12);
        }

        .tbo-popular-badge {
          position: absolute;
          top: 20px;
          right: 30px;
          background: #2563eb;
          color: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.85rem;
          z-index: 10;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

        .tbo-pricing-card-content {
          display: grid;
          grid-template-columns: 1fr 1.2fr;
        }

        .tbo-pricing-left {
          padding: 40px;
          border-right: 1px solid #eef2f6;
        }

        .tbo-pricing-emoji {
          font-size: 2.5rem;
          margin-bottom: 15px;
        }

        .tbo-pricing-name {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 10px;
          color: #0f172a;
        }

        .tbo-pricing-description {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 25px;
        }

        .tbo-pricing-amount {
          margin-bottom: 25px;
        }

        .tbo-currency {
          font-size: 1.2rem;
          font-weight: 600;
          color: #64748b;
          margin-right: 5px;
        }

        .tbo-price {
          font-size: 3.5rem;
          font-weight: 800;
          color: #0f172a;
          line-height: 1;
        }

        .tbo-pricing-period {
          font-size: 1rem;
          color: #64748b;
          margin-left: 5px;
        }

        .tbo-pricing-cta {
          width: 100%;
          border: none;
          padding: 16px;
          border-radius: 12px;
          color: white;
          font-weight: 600;
          font-size: 1.1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-bottom: 30px;
        }

        .tbo-pricing-cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }

        .tbo-quick-setup {
          background: #f8fafc;
          border-radius: 16px;
          padding: 20px;
        }

        .tbo-setup-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          color: #0f172a;
        }

        .tbo-setup-steps {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .tbo-setup-step {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .tbo-step-marker {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 0.9rem;
          flex-shrink: 0;
        }

        .tbo-step-content {
          display: flex;
          flex-direction: column;
        }

        .tbo-step-content strong {
          font-size: 0.95rem;
          margin-bottom: 4px;
        }

        .tbo-step-content span {
          font-size: 0.85rem;
          color: #64748b;
        }

        .tbo-pricing-right {
          padding: 40px;
          background: #ffffff;
        }

        .tbo-features-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .tbo-addons-title {
          margin-top: 30px;
        }

        .tbo-features-list,
        .tbo-addons-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .tbo-feature-item,
        .tbo-addon-item {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .tbo-feature-check,
        .tbo-addon-check {
          width: 22px;
          height: 22px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .tbo-feature-check i,
        .tbo-addon-check i {
          font-size: 14px;
        }

        .tbo-feature-item span,
        .tbo-addon-item span {
          font-size: 0.95rem;
          color: #334155;
          line-height: 1.5;
        }

        .tbo-pricing-footer {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
        }

        .tbo-support-link {
          cursor: pointer;
          font-weight: 500;
        }

        .tbo-support-link:hover {
          text-decoration: underline;
        }

        /* Accessibility */
        .tbo-clickable:focus-visible {
          outline: 3px solid #2563eb;
          outline-offset: 2px;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .tbo-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
          
          .tbo-services-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .tbo-benefits-grid-full {
            grid-template-columns: 1fr;
          }

          .tbo-process-steps {
            grid-template-columns: 1fr;
          }

          .tbo-logo-grid {
            grid-template-columns: repeat(3, 1fr);
          }

          .tbo-pricing-card-content {
            grid-template-columns: 1fr;
          }

          .tbo-pricing-left {
            border-right: none;
            border-bottom: 1px solid #eef2f6;
          }

          .tbo-contact-info {
            flex-direction: column;
            align-items: center;
          }

          .tbo-contact-item {
            width: 100%;
            max-width: 400px;
          }
        }

        @media (max-width: 768px) {
          .tbo-title {
            font-size: 2.5rem;
          }
          
          .tbo-highlight {
            font-size: 3rem;
          }
          
          .tbo-tabs {
            gap: 20px;
            overflow-x: auto;
            padding-bottom: 5px;
          }
          
          .tbo-tab {
            font-size: 0.95rem;
            white-space: nowrap;
          }
          
          .tbo-services-grid {
            grid-template-columns: 1fr;
          }
          
          .tbo-section-title {
            font-size: 2rem;
          }

          .tbo-features {
            grid-template-columns: 1fr;
          }

          .tbo-logo-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .tbo-supplier-stats-simple {
            flex-direction: column;
            gap: 20px;
          }

          .tbo-contact-section {
            padding: 40px 20px;
          }

          .tbo-contact-section h3 {
            font-size: 1.8rem;
          }

          .tbo-contact-item {
            padding: 15px 20px;
          }

          .tbo-contact-value {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .tbo-header {
            padding: 60px 0 30px;
          }

          .tbo-logo-grid {
            grid-template-columns: 1fr;
          }

          .tbo-pricing-left,
          .tbo-pricing-right {
            padding: 25px;
          }

          .tbo-price {
            font-size: 2.5rem;
          }

          .tbo-billing-toggle {
            flex-direction: column;
            width: 100%;
            border-radius: 12px;
          }

          .tbo-toggle-btn {
            width: 100%;
          }

          .tbo-contact-item {
            flex-direction: column;
            text-align: center;
          }

          .tbo-contact-details {
            align-items: center;
          }
        }
      `}</style>
    </>
  );
};

// Simple Helmet component for meta tags
const Helmet = ({ children }) => {
  return <>{children}</>;
};

export default TBOSupplierHighlight;